module.exports = __webpack_public_path__ + "static/media/cf72ffcf.jpg";